import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as d3 from 'd3';
import moment from "moment";
import * as lodash from 'lodash'
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { Arc, DefaultArcObject } from 'd3'
import { style } from '@angular/animations';
import { Vega, Legend, Tooltip } from '@dataunveil/ducharts';
import { ChartsModule } from '../../shared/charts/charts.module';
import widgetModel from '../widget.model';
import config from '../grid-page/config';
import { DynamicCustomTooltipService } from 'src/app/services/dynamic-custom-tooltip.service';
import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';

@Component({
    // standalone: true,
    // imports: [Vega, Legend, Tooltip,CommonModule,ChartsModule,],
    selector: 'app-pie-chart-card',
    templateUrl: './pie-chart-card.component.html',
    styleUrls: ['./pie-chart-card.component.scss'],
    standalone: false
})
export class PieChartCardComponent implements OnInit, OnDestroy {
  private readonly noDataNotifier = inject(NoDataNotifierService);
  static key = 100708;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("pieChartDiv", { static: true }) pieChartDiv!: ElementRef;
  @ViewChild('pieChartTooltip') pieChartTooltip!: ElementRef| any
  @ViewChild("fs") fs!: ElementRef;
  @HostBinding("class.is-fullscreen") isFullscreen = false;
  @Input("dynamic") dynamic!: any;
  data: any
  heading: any;
  isActive = false;
  isDataLoaded = false;
  reqSubcription: Subscription[] = [];
  sourceName: any;
  pieData: any;
  config: any;
  isLoading: boolean = false;
  noData: boolean = false;
  FilterString: any = 'History Patient Count'
  DonutId: string = 'chart'
  total: any
  legendData: any;
  chartType: any;
  dataTurn: any
  tooltip = false;
  mytooltipData:any
  error_name:any;
  
   @HostListener("window:resize", ["$event"])
       onResize(event: Event) {
         setTimeout(() => {
           this.pieConfig(this.item?.config?.divid);
         }, 100);
       }

  therapyStats:any = [
    { prefix: '',value: 31, unit: 'days', suffix: '',description: 'median time on concurrent therapy' },
    { prefix: '',value: 75, unit: 'days', suffix: '',description: 'average time on concurrent therapy' },
    { prefix: '', value: 5, unit: 'days', suffix: '',description: 'failed Jakafi or Imbruvica before taking Rezurock' }
  ];
  constructor(public filterService: FilterService,private viewContainerRef: ViewContainerRef,  private dynamicCustomTooltipService: DynamicCustomTooltipService,private currency: CurrencyPipe, private httpClient: HttpClient, private apiService: ApiService) {
    // Filter Loads
    this.reqSubcription.push(this.filterService.filterQuery.subscribe((query: any) => {
      this.loadApiData();
      this.isLoading = true
    }));
   
        // Nested Widgets
      this.reqSubcription.push(
        this.filterService.triggerNestedQuery.subscribe((query: any) => {
          if(query == this.item.widget_uniq_key) {
            this.loadApiData();
            this.isLoading = true;
          }
        })
      );
  }

  ngOnInit(): void {
    this.isLoading = true
    const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
  for (let entry of entries) {
    const { width, height } = entry.contentRect;

    // If you still want to emit height:
    this.onSizeChange.emit(height);
  }
});

observer.observe(this.pieChartDiv.nativeElement);

    this.loadlineConfig();
    // if (this.dynamic == true) {
    //   this.loadApiData()
    // }
  }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
  }
   private showTooltip(event:any,myType: any, myData: any, myX: any, myY: any, chartWidth: any): void {
      this.mytooltipData = myData
      this.dataTurn = 0
      this.dataTurn = chartWidth - myX
      this.tooltip=true
      this.dynamicCustomTooltipService.createMouseTooltip(this.pieChartTooltip, this.viewContainerRef, event);
      // const pieTooltip = d3.select(this.pieChartTooltip.nativeElement).select("#d3pieTooltip")
      // if (this.dataTurn < 100) {
      //   pieTooltip
      //     .style('visibility', 'visible')
      //     .style('position', 'absolute')
      //     .style('top', (myY + 30) + 'px')
      //     .style('left', ( myX - 90) + 'px')
      //     .style('right', 'unset')
      //     .style('bottom', 'unset')
      // }else if (this.dataTurn > 100) {
      //   pieTooltip
      //     .style('visibility', 'visible')
      //     .style('position', 'absolute')
      //     .style('top', (myY + 20) + 'px')
      //     .style('left', (myX + 40) + 'px')
      //     .style('right', 'unset')
      //     .style('bottom', 'unset')
      //   }
    }
  
    // Created once on mouseover (showTooltip) and only moved here. Recreating the overlay
    // on every mousemove, as before, made it flicker - the tree-map and sankey-beeswarm
    // charts already do it this way.
    private moveTooltip(event: MouseEvent): void {
      this.dynamicCustomTooltipService.updateTooltipPosition(this.pieChartTooltip, this.viewContainerRef, event);
    }

    private hideTooltip(myType: any): void {
       this.dynamicCustomTooltipService.hideMouseTooltip();
      // this.tooltip = false
      // d3.select(this.pieChartTooltip.nativeElement).select("#d3bulletTooltip")
    }

  loadApiData(api_key?: any) {
    // debugger
    let api = this.item.config["list_of_api"] || {};
    let cardapi = this.item.config["status_card_api"] || {};
    let widgetEndpoint = this.item?.config?.['widget_endpoint']||null;
    
    if (this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {

      // API Payload
      let obj: any = { "api_key": api_key ? api_key : api }
      let cardobj: any = { "api_key": cardapi }
      this.isDataLoaded = false;
      let query = Object.assign({}, this.filterService.baseQuery, obj)
      query["report_typ"] = this.filterService.report_type;
      query['module_key'] = this.apiService.getModuleKey();
      let cardquery = Object.assign({}, this.filterService.baseQuery, cardobj)
      cardquery["report_typ"] = this.filterService.report_type;

      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${widgetEndpoint??this.apiService.executionUrl}`, query).subscribe((res: any) => {
          this.data = res?res.map((item:any) => ({
          ...item,
          type: item.type ?? "History Patient Count" // if missing, set static type
        })):[]
    
          this.pieData = this.item['config']['chart_type'].name == 'pieChart' ? this.data.filter((f: any) => f.type == this.FilterString) : this.data
          this.isDataLoaded = true
          this.isLoading = false
          if (this.data.length == 0) { this.noData = true; this.noDataNotifier.report('pie-chart-card') } else { this.noData = false }
          this.error_name = '';
          this.pieConfig(this.item.config.divid);
        }, (err: any) => {
          console.log(err)
          this.pieData = []
          this.noData = true; this.noDataNotifier.report('pie-chart-card')
          this.isLoading = false
          this.isDataLoaded = true;
          this.error_name = friendlyApiErrorMessage(err);
          this.pieConfig(this.item.config.divid);
        })
      );

      // The status card API is only configured when the card is shown, so
      // without this guard api_key goes out as {} and the request fails.
      if (this.item?.config?.['statusCard']) {
        this.reqSubcription.push(
         this.httpClient.post(`${this.apiService.apiBaseUrl}/${widgetEndpoint??this.apiService.executionUrl}`, cardquery).subscribe((res: any) => {
           
           this.therapyStats=res.length>0 ? res : [{ prefix: '',value: 0, unit: 'days', suffix: '',description: 'NO DATA' }]
           console.log( this.therapyStats);
           
          this.pieConfig(this.item.config.divid);
        }, (err: any) => {
          console.log(err)
         this.therapyStats=[{ prefix: '',value: 0, unit: 'days', suffix: '',description: 'NO DATA' }]
        })
        );
      }

    }
  }

  @HostListener('fullscreenchange')
  @HostListener('webkitfullscreenchange')
  @HostListener('mozfullscreenchange')
  @HostListener('MSFullscreenChange')
  screenChange () {
    this.screenChanges(!!document.fullscreenElement);
  }

  screenChanges(event: any) {
    this.isActive = event
    this.isFullscreen = event
    this.config = {}
    this.pieConfig(this.item.config.divid)

  }

  pieConfig(name: string) {

    this.DonutId = 'chart' + name
    this.total = lodash.sumBy(this.pieData, 'value');
    this.chartType = this.item['config']['chart_type'].name;

    if (this.item['config']['chart_type'].name == 'DonutpieChart') {

      setTimeout(() => {
        this.donutPieConfig(this.data, 'type')
        let piedata:any=this.groupByAndSum(this.data, 'label' )
        this.bindChart(name+'pie',piedata,'P');
        let donutdata:any=this.groupByAndSum(this.data, 'type')
        this.bindChart(name,donutdata,"D");
      }, 50);
    } else {
      setTimeout(() => {
        this.donutPieConfig(this.pieData, 'category')
        let donutdata:any=this.groupByAndSum(this.pieData, 'category')
        // debugger
        this.bindChart(name,donutdata,"D");
      }, 50);
    }

  }
  donutPieConfig(data: any, label: string) {

    this.total = lodash.reduce(data, (acc, v) => acc + v.value, 0)
    const colorScheme: any =this.item['config']['static_color'] ? JSON.parse(this.item['config']['color_palette'].replace(/'/g, '"')) :['#FFB039', '#5F5196', '#2CB239', '#7AD045', '#25D3EB', '#1566DE', '#7848FF', '#CB04DC', '#FA195C', '#9E0000', '#EACD37', '#DD630B', '#BCD03F', '#14BDA9', '#8A05F3', '#D9476A', '#2DADB6', '#E468C2', '#199CD4', '#0934CC'];
    var index: any = 0
    this.legendData = lodash.map(data, d => {
      index = index + 1
      return {
        label: d[label],
        info: label=='category' ? d3.format('.0%')(d.value / this.total)+' ('+(this.numbedPipe(d.value))+')' : `${d.value} days (${d3.format('.0%')(d.value / this.total)})`,
        color: colorScheme[index - 1],
      }
    })
  }

  bindChart(id: any,data:any,chartType:string) {
    const myChart = this
    // Look the container up inside this card. divid comes from config and isn't unique per
    // widget, so a page-wide '#chart' + id lookup could reach another donut with the same
    // id - including the previous tab's, which stays in the DOM while the tabs switch.
    const chartRoot = d3.select(this.pieChartDiv.nativeElement).select('#chart' + id)
    chartRoot.select('svg').remove()
    const colors: any = this.item['config']['static_color'] ? JSON.parse(this.item['config']['color_palette'].replace(/'/g, '"')) :['#FFB039', '#5F5196', '#2CB239', '#7AD045', '#25D3EB', '#1566DE', '#7848FF', '#CB04DC', '#FA195C', '#9E0000', '#EACD37', '#DD630B', '#BCD03F', '#14BDA9', '#8A05F3', '#D9476A', '#2DADB6', '#E468C2', '#199CD4', '#0934CC']
    var datatest: any[] = data 
    for (let index = 0; index < datatest.length; index++) {
      datatest[index]['color'] = colors[index]
    }
    var width  = 370;
    var height = 370;
    var outerRadius= 0;
    var innerRadius= 0;

    if(this.item?.config?.static_width_height){
      width = chartType=='P'?(this.isFullscreen ? 300 : 120):(this.isFullscreen ? 300 : 200),
      height =chartType=='P'?(this.isFullscreen ? 200 : 120): (this.isFullscreen ? 300 : 200);

     outerRadius =chartType=='P'? 0 : (this.isFullscreen ? 120 : 70)
     innerRadius =chartType=='P'?(this.isFullscreen ? 100 : 60): (this.isFullscreen ? 150 : 100)
   
    }else{
      // ✅ Get container width dynamically
      const container = chartRoot.node() as HTMLElement;
      let clientWidth =   container.getBoundingClientRect().width;

      // ✅ Responsive width/height (max 500px)
       width = Math.min(clientWidth, this.item?.config?.width||370);
       height = width; // keep it square

      // ✅Dynamic radius based on width
       outerRadius = chartType == 'P' ? width / 4 : width / 2.5;
       innerRadius = chartType == 'P' ? width / 6 : width / 3;
    }

    var pie1 = d3
      .pie()
      .value((d: any) => {
        return d.value;
      })
      .sort(null);

    let arc: Arc<any, DefaultArcObject> = d3
      .arc()
      .outerRadius(outerRadius)
      .innerRadius(innerRadius)
      .cornerRadius(6)
      .padAngle(0);

    // Hover grows a slice by tweening its radii (k: 0 = resting, 1 = hovered) and redrawing
    // it with d3.arc every frame. The old .transition().attr('d', outerArc(d)) interpolated
    // the two path strings number by number, and for a slice near 180 degrees the hover
    // shape's bigger corners flip the SVG large-arc flags: halfway through they were
    // fractions, an invalid path the browser stops drawing, so the slice vanished from under
    // the cursor - mouseout, shrink back, mouseover: the flicker. Frozen mid-way by that
    // loop, the slice was left half-drawn.
    const hoverArc = (d: any, k: number) => d3.arc()
      .outerRadius(outerRadius + 8 * k)
      .innerRadius(innerRadius - 8 * k)
      .cornerRadius(6 + 2 * k)
      .padAngle(0)(d)
    const tweenHover = (node: any, d: any, to: number) => {
      const from: number = node.__hoverK ?? 0
      d3.select(node)
        .transition()
        .duration(200)
        .attrTween('d', () => (t: number) => {
          node.__hoverK = from + (to - from) * t
          return hoverArc(d, node.__hoverK) as string
        })
    }

    var svg: any = chartRoot
      .append('svg')
      .attr('width', width+20)
      .attr('height', height+20)
      .append('g')
      .attr('transform', 'translate(' + (width+20) / 2 + ',' + (height+20) / 2 + ')');

    var path = svg
      .selectAll('path')
      .data(pie1(datatest as any))
      .enter()
      .append('path')
      .attr('d', arc)
      .attr('fill', function (d: any) {
        return d.data.color;
      }).on('mouseover', function (event: MouseEvent, d: DefaultArcObject) {
    //@ts-ignore
    tweenHover(this, d, 1)
      //@ts-ignore
        myChart.showTooltip(event,'bar',d.data,event.offsetX, event.offsetY,width)
  }).on("mousemove", function (event: MouseEvent) {
        myChart.moveTooltip(event)
  })
  .on('mouseout', function (event: MouseEvent, d: DefaultArcObject) {
    //@ts-ignore
    tweenHover(this, d, 0)
      //@ts-ignore
      myChart.hideTooltip('bar')
  });
      
    path
      .transition()
      .duration(1000)
      .attrTween('d', function (d: any) {
        const interpolate = d3.interpolate({ startAngle: 0, endAngle: 0 }, d);
        return function (t: any) {
          return arc(interpolate(t));
        };
      })
  
    var restOfTheData = function () {
      var text = svg
        .selectAll('text')
        .data(pie1(datatest as any))
        .enter()
        .append('text')
        .transition()
        .duration(200)
        .attr('transform', function (d: any) {
          return 'translate(' + arc.centroid(d) + ')';
        })
        .attr('dy', '.4em')
        .attr('text-anchor', 'middle')
        .text(function (d: any) {
          return  chartType=='P'? d.data.label:undefined;
        })
        .style('fill', '#fff')
        .style('font-family', 'poppins')
        .style('font-size', '9px');

    };

    setTimeout(restOfTheData, 100);
  }

  groupByAndSum(data: any, key: any) {
    return Object.values(data.reduce((result: any, currentValue: any) => {
      const name = currentValue[key];
      result[name] = result[name] || { ...currentValue, value: 0, color: '' };
      result[name].value += currentValue.value;
      return result;
    }, {}));
  }
  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
   // numberFormat
  numbedPipe(value: any) {
    return this.currency.transform(value, '', '', '1.0-2');
    //  return   this.numberpipe.transform(value)
  }
  test(item:any) {
    // console.log(item)
    // this.data=this.pieData
    // this.pieData= this.data.filter((f:any)=>f.type==item.label)
    // this.pieConfig(this.item.config.divid);
  }
  getQuarter(date: string, format: string = 'Q-YYYY'): string {
  if (!date) return '';

  const m = moment(date, 'YYYY-MM-DD');
  const q = m.quarter();
  const year = m.year();

  switch (format.toLowerCase()) {
    case 'q':
      return `Q${q}`;
    case 'q-yyyy':
      return `Q${q} ${year}`;
    case 'yyyy-q':
      return `${year}-Q${q}`;
    default:
      return `Q${q} ${year}`; // fallback
  }
}
showByChanges(event:any) {
        
    if (this.item['config']['chart_type'].name != 'DonutpieChart') {
      this.isLoading = true
      this.FilterString = event.value
      this.pieData = this.data.filter((f: any) => f.type == event.value)
      this.pieConfig(this.item.config.divid);
      setTimeout(() => {
        this.isLoading = false
      }, 200);
   }
      
  }

}
